import CountryService from "app/services/CountryService";
import { allTrackers } from "app/services/track/track";

export const headerTracking = {
    filterCountrySelect: (countryCodes: number[]): void => {
        countryCodes.forEach((countryCode) => {
            allTrackers.dispatchTrackEvent(
                "Drop Down",
                "click",
                `Header/Country/${CountryService.getCountryById(countryCode)?.text ?? ""}`,
            );
        });
    },
    filterDeviceSelect: (deviceName: string, countryCodes: number[]): void => {
        allTrackers.dispatchTrackEvent("Drop Down", "click", `Header/Traffic type/${deviceName}`, {
            country: countryCodes.join(","),
        });
    },
};
